/** @jsxImportSource @emotion/react */
'use memo'

import styled from '@emotion/styled'
import { useHistory } from 'react-router-dom'
import { UsergroupAddOutlined } from '@ant-design/icons'
import colors from '@sportninja/common/constants/appColors'
import { ROUTES } from '@sportninja/common/constants/app'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import Button from 'src/components/ts-components/Button'
import Text from 'src/components/ts-components/Text'

/**
 * Entry point into the Team Finder, shown in the My Registrations page header,
 * opposite the title: the compact header `Button` with a muted helper line
 * beneath it.
 */
const JoinTeamButton = () => {
  const history = useHistory()

  return (
    <Wrapper>
      <Button
        text={capitalizeWords('Find a Team')}
        variant='primary'
        size='compact'
        onClick={() => history.push(ROUTES.TEAM_FINDER)}
        icon={<UsergroupAddOutlined />}
      />
      <Text variant='paragraphSmall' weight='regular' color={colors.NEUTRAL_50}>
        Find open registrations in your area
      </Text>
    </Wrapper>
  )
}

export default JoinTeamButton

// ---- styled ----
// Right-aligned so the button and its helper line share the header's edge.
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
`
